/**
 * DesktopLayout - 3-column layout for desktop
 *
 * Structure:
 * [Sidebar (72px collapsed)] [Main Content (flex)] [Right Panel (360px)]
 *
 * Features:
 * - Sidebar overlays on expand (doesn't push content)
 * - Right panel optional
 * - Feature flag to show/hide sidebar
 */

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { DesktopSidebar } from '@/components/navigation/DesktopSidebar';
import type { DesktopLayoutProps } from './types';
import { DisclaimerFooter } from '@components/common/DisclaimerFooter';

export const DesktopLayout: React.FC<DesktopLayoutProps> = ({
  children,
  rightPanel,
  showSidebar = false, // Default off for safety
}) => {
  return (
    <View style={styles.container}>
      {/* Sidebar - Overlays on expand */}
      <DesktopSidebar visible={showSidebar} />

      {/* Main Content */}
      <View style={[styles.mainContent, showSidebar && styles.mainContentWithSidebar]}>
        {children}
      </View>

      {/* Right Panel - Optional */}
      {rightPanel && <View style={styles.rightPanel}>{rightPanel}</View>}
      <DisclaimerFooter />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    overflow: 'hidden',
  },
  mainContent: {
    flex: 1,
    minWidth: 0, // Prevent flex overflow
  },
  mainContentWithSidebar: {
    marginLeft: 72, // Space for collapsed sidebar
  },
  rightPanel: {
    width: 360,
    flexShrink: 0,
  },
});
